import { render, staticRenderFns } from "./PositionTemplateSelector.vue?vue&type=template&id=6cee792c&"
import script from "./PositionTemplateSelector.vue?vue&type=script&lang=js&"
export * from "./PositionTemplateSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports